import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
  name: 'formatTime',
})
export class FormatTimePipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (value) {
      return moment(value).format("HH:mm");
    } else {
      return '-';
    }
  }
}